import React from 'react'
import Footer from '../Footer/Footer'
import About from '../hero/About'
import Amenities from '../hero/Amenities'
import Hero from '../hero/Hero'
import HotelRooms from '../hero/HotelRooms'
import HotelsCards from '../hero/HotelsCards'
import Navbar from '../hero/Navbar'
import SearchForm from '../hero/SearchForm'
import Restaurant from '../hero/Restaurant/Restaurant'

const Homepage = () => {
  return (
    <div>
        <Navbar/>
        <Hero/>
        <SearchForm/>
        <About/>
        <HotelsCards/>
        <HotelRooms/>
        <Restaurant/>
        <Amenities/>
        <Footer/>
    </div>
  )
}

export default Homepage